import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

export const reviewPost = createAsyncThunk(
    "website/review",
    async (data, { rejectWithValue }) => {
        try {
            const response = await POST(APIS.reviewRating.REVIEWRATING, data);
            if (response?.success) {
                return response;
            }

            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const reviewPUT = createAsyncThunk(
    "website/review",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await PUT(APIS.reviewRating.REVIEWRATING + `/${id}`, data);
            if (response?.success) {
                return response;
            }

            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const getSingleReview = createAsyncThunk(
    "website/get-review",
    async (id, { rejectWithValue }) => {
        try {
            const response = await GET(APIS.reviewRating.REVIEWRATING + `/single/${id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const AvgReviewRating = createAsyncThunk(
    "get-review-rating",
    async ({ product_id }, { rejectWithValue }) => {
        try {
            const termsconditionsData = await GET(
                `${APIS.reviewRating.AVG_REVIEW_RATING}/${product_id}`
            );
            return termsconditionsData;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const allReviewRating = createAsyncThunk(
    "al-review-rating",
    async ({ product_id }, { rejectWithValue }) => {
        try {
            const termsconditionsData = await GET(`${APIS.reviewRating.REVIEWRATING}/${product_id}`);
            return termsconditionsData;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const reviewRatingSlice = createSlice({
    name: "reviewRating",
    initialState: {
        all_rating: [],
        avg_rating: "",
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(allReviewRating.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(allReviewRating.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.all_rating = action.payload?.data || [];

            })
            .addCase(allReviewRating.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;

            })

            .addCase(AvgReviewRating.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(AvgReviewRating.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.avg_rating = action.payload?.data || false;
            })
            .addCase(AvgReviewRating.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            .addCase(reviewPost.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(reviewPost.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(reviewPost.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
    },
});

export default reviewRatingSlice.reducer;




